<mat-card appearance="outlined" class="cardLocation">
	<span style="padding-left:15px;padding-top:5px;font-size:19px;font-weight:500;">Location</span>
	<mat-card-content>
		<div class="row">
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
				<mat-label>Region(s)</mat-label><br>
				<!--  *ngIf="!isLoadingResults" {{selectedRegionIds}}   [selectRegionIds]="[school?.REGIONS!.ID]" -->
				<region-dropdown-two-way id="myRegion" class="restrictWidth" [isMultiple]="true" [(selectedRegions)]="chosenRegions"
					[allowAllRegions]="true" (selectedRegionsChange)="regionsSelected($event)"  [reset]="resetFieldRegions" #child2>
				</region-dropdown-two-way> 
			</div>
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
				<mat-label>County(s)</mat-label><br>
				<!--*ngIf="!isLoadingResults" [selectCountyIds]="selectedCountyIds" [selectCountyIds]="[school?.COUNTy!.ID]"-->
				<county-dropdown-two-way id="myCounty1"  [isMultiple]="true" [reset]="resetFieldCounties" [regions]="chosenRegions" (selectedCountiesChange)="countiesSelected($event)" #child3></county-dropdown-two-way> 
			</div>
		</div>
		<div *ngIf="showDistrictDropdown" class="row">
			<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
				<mat-label>District(s)</mat-label><br>
				<!-- *ngIf="!isLoadingResults" [selectSchoolDistrictIds]="[selectedSchoolDistrictId]"  [selectSchoolDistrictIds]="[selectedSchoolDistrictId]"  -->
				<!-- <district-dropdown (eventEmitterSchoolDistrict)="districtsSelected($event)"
					[reset]="resetFieldDistricts" #child>
				</district-dropdown>-->
			</div>
		</div>
	</mat-card-content>
</mat-card>